const addZeroPadding = (entity) => {
    if (entity < 10) {
        return `0${entity}`;
    }
    return entity;
};
/**
 * Format a date as ddmmyyyyhhmm
 *
 * @param {Date} date
 *
 * @returns {string}
 */
export const formatDate = (date) => {
    const day = addZeroPadding(date.getDate());
    const month = addZeroPadding(date.getMonth() + 1);
    const hour = addZeroPadding(date.getHours());
    const minutes = addZeroPadding(date.getMinutes());
    return `${day}${month}${date.getFullYear()}${hour}${minutes}`;
};
